import { render, staticRenderFns } from "./CandidateExamItem.vue?vue&type=template&id=1b53aa68&scoped=true&lang=pug&"
import script from "./CandidateExamItem.vue?vue&type=script&lang=js&"
export * from "./CandidateExamItem.vue?vue&type=script&lang=js&"
import style0 from "./CandidateExamItem.vue?vue&type=style&index=0&id=1b53aa68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b53aa68",
  null
  
)

export default component.exports